namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem9ExemptColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem9Exempt';
    }
}
